<script>
import forminput from "../../FormComponet/forminput.vue";
import formcombobox from "../../FormComponet/formcombobox.vue";
import formcheckbox from "../../FormComponet/formcheckbox.vue";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrPerfTablo from "@/models/StrPerfTablo"; 
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiAnaBirim.vue";
export default {
  mixins: [Api, Sabit, StrPerfTablo],
  props: ["Id", "AddEdit"],
  data() {
    return {
      FormData: {},
    };
  },
  components: {
    Loader,
    forminput,
    formcheckbox,
    formcombobox,
    BirimSecimi
  },
  watch: {
    Id() {
      this.FormData = this.Id;
    },

  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {

         if (this.FormData.Aktif == "true" || this.FormData.Aktif == true) {
          this.FormData.Aktif = true;
        } else {
          this.FormData.Aktif = false;
        }

        if (this.AddEdit == "Add") { 
           this.$delete(this.FormData, "Id");
              this.Post("StrPerfTablo", this.FormData).then((res) => {
            if (res) {
              this.$emit("TableUpdate", this.FormData);
              this.$bvModal.hide("StrPerfTablo");
            }
              });
        } else {
         
         this.Update("StrPerfTablo", this.FormData).then((res) => {
              if (res) {
                this.$emit("TableUpdate", this.FormData);
                this.$bvModal.hide("StrPerfTablo");
              }
         });

        }
      }
    },
    Get(){
      
    },
    amac_yukle(DonemId){
      let Page= {
        PageNumber: "1",
        PageSize: "9999"
      }


          let Filter = "&DonemId="+DonemId;
          this.FormDataType.AmacId.ComboDataArray=[];

      this.ActionsFilterGet({"Service":"StrStratejikAmac", "Page":Page,Filter:Filter}).then((res) => {
                for(var i=0; i<res.Data.length; i++)
                {
                  this.FormDataType.AmacId.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Aciklama})
                } 
      
          });

    }
  },
};
</script>

<template>


  <Loader>

  
    <b-modal
      id="StrPerfTablo"
      size="lg"
       :title="this.AddEdit == 'Edit'  ? 
          $t('StrPerfTablo.AddEdit.FormTitleEdit')
          : $t('StrPerfTablo.AddEdit.FormTitleAdd')"
      title-class="font-18"
      hide-footer
    >


        <Form @submit.prevent="onSubmit">
          <div class="row">
            <div class="col-md-12">
              <forminput
                :title_position="'mb-3'"
                :labels_lg="3"
                :FormDataType="FormDataType.Adi"
                :Value="FormData.Adi"
                :v="$v.FormData.Adi"
                @input="FormData.Adi = $event"
              />   

            </div>
          </div>

          <div class="row">
            <div class="col-md-12">

              <formcombobox
                  :title_position="'mb-3'"
                  :labels_lg="3"
                  :FormDataType="FormDataType.DonemId"
                  :Value="FormData.DonemId"
                  :v="$v.FormData.DonemId"
                  @input="FormData.DonemId = $event,amac_yukle($event)"
                />

              
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">

               <formcombobox
                  :title_position="'mb-3'"
                  :labels_lg="3"
                  :FormDataType="FormDataType.AmacId"
                  :Value="FormData.AmacId"
                  :v="$v.FormData.AmacId"
                  @input="FormData.AmacId = $event"
                />

            </div>
          </div>

          

          <div class="row">
            <div class="col-md-12">
              

                  <BirimSecimi
                    :title="FormDataType.BirimId.FieldTitle"
                    :sutun="'3'" 
                    :title_class="'mb-3'"
                    :selected="FormData.BirimId" 
                    :v="$v.FormData.BirimId"
                    :multiple="false"
                    :BirimTipId="null"
                    @Secilmis_Idler="FormData.BirimId=$event"
                  />
          

            </div>
          </div>

          <div class="row">
            <div class="col-md-12">

              <forminput
                :title_position="'mb-3'"
                :labels_lg="3"
                :FormDataType="FormDataType.Hedefi"
                :Value="FormData.Hedefi"
                :v="$v.FormData.Hedefi"
                @input="FormData.Hedefi = $event"
              />   


            </div>
          </div>

          <div class="row">
            <div class="col-md-12">

               <forminput
                :title_position="'mb-3'"
                :labels_lg="3"
                :FormDataType="FormDataType.PerformansHedefi"
                :Value="FormData.PerformansHedefi"
                :v="$v.FormData.PerformansHedefi"
                @input="FormData.PerformansHedefi = $event"
              />  
             
            </div>
          </div>
                      <div class="col-md-12">
              <forminput
                :title_position="'mb-3'"
                :labels_lg="3"
                :FormDataType="FormDataType.Programad"
                :Value="FormData.Programad"
                :v="$v.FormData.Programad"
                @input="FormData.Programad = $event"
              />   

            </div>

                        <div class="col-md-12">
              <forminput
                :title_position="'mb-3'"
                :labels_lg="3"
                :FormDataType="FormDataType.Programhedef"
                :Value="FormData.Programhedef"
                :v="$v.FormData.Programhedef"
                @input="FormData.Programhedef = $event"
              />   

            </div>

          <div class="row">
            <div class="col-md-12">

               <forminput
                :title_position="'mb-3'"
                :labels_lg="3"
                :FormDataType="FormDataType.Notu"
                :Value="FormData.Notu"
                :v="$v.FormData.Notu"
                @input="FormData.Notu = $event"
              />  

            </div>
          </div>

          <div class="row">
            <div class="col-md-12">

                <forminput
                :title_position="'mb-3'"
                :labels_lg="3"
                :FormDataType="FormDataType.SiraNo"
                :Value="FormData.SiraNo"
                :v="$v.FormData.SiraNo"
                @input="FormData.SiraNo = $event"
              />  

            </div>
          </div>

          <div class="row">
            <div class="col-md-12">

               <formcheckbox
                :title_position="'mb-3'"
                :labels_lg="3"
                :FormDataType="FormDataType.Aktif"
                :Value="FormData.Aktif"
                :v="$v.FormData.Aktif"
                @input="FormData.Aktif = $event"
              />

              
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">

               <formcheckbox
                :title_position="'mb-3'"
                :labels_lg="3"
                :FormDataType="FormDataType.HedefGirilsin"
                :Value="FormData.HedefGirilsin"
                :v="$v.FormData.HedefGirilsin"
                @input="FormData.HedefGirilsin = $event"
              />

              
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">

               <formcheckbox
                :title_position="'mb-3'"
                :labels_lg="3"
                :FormDataType="FormDataType.HarcamaGirisiPasif"
                :Value="FormData.HarcamaGirisiPasif"
                :v="$v.FormData.HarcamaGirisiPasif"
                @input="FormData.HarcamaGirisiPasif = $event"
              />

              
            </div>
          </div>

          <hr />

          <button class="btn btn-primary" type="submit">{{ $t("StrPerfTablo.AddEdit.Button") }}</button>
        </Form>


    </b-modal>
  </Loader>
</template>
